import { API_LOGIN, API } from "./ApiConfig";
const URL_GRUPO = "/auth";
const URL_REGISTRO = "/register";
const URL_REGISTRO_EMPRESA = "/registrarEmpresa";
const URL_CREAR_EMPRESA = "/crearEmpresa";
const URL_LOGIN = "/login";
const URL_PARAMS_INICIALES = "/getParametrosInicio";
const URL_BACKENDS = "/backend";

//Crear usuarios
export const RegistrarRequest = async (data) => {
  const request = await API_LOGIN.post(URL_GRUPO + URL_REGISTRO, data);
  const response = request.data;
  return response;
};

//Login
export const LoginRequest = async (data) => {
  const request = await API_LOGIN.post(URL_GRUPO + URL_LOGIN, data);
  const response = request.data;
  return response;
};

//Parametros iniciales
export const GetParametrosInicioRequest = async (cod_sucur) => {
  const request = await API.get(URL_GRUPO + URL_PARAMS_INICIALES + `/${cod_sucur}`);
  const response = request.data;
  return response;
};

//Parametros iniciales
export const GetBackendsRequest = async (nro_emp) => {
  const request = await API_LOGIN.get(URL_GRUPO + URL_BACKENDS + "/" + nro_emp);
  const response = request.data;
  return response;
};

//Traer backends
export const GetBackendAllRequest = async () => {
  const request = await API_LOGIN.get(URL_GRUPO + URL_BACKENDS);
  const response = request.data;
  return response;
};

//Crear vinculados
export const RegistrarEmpresaRequest = async (data) => {
  const request = await API_LOGIN.post(URL_GRUPO + URL_REGISTRO_EMPRESA, data);
  const response = request.data;
  return response;
};

//Crear Empresa
export const CrearEmpresaRequest = async (data) => {
  const request = await API_LOGIN.post(URL_GRUPO + URL_CREAR_EMPRESA, data);
  const response = request.data;
  return response;
};
